import { colorSet } from '@components/Provider';
import { Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import * as assets from '@assets';
import { CustomizedTypography } from '@components/Customized';
import { useHistory } from 'react-router-dom';

interface Props {
  quotationForm?: React.ReactNode;
  requestForm?: React.ReactNode;
  isQuotation: boolean;
}

const ClipBoardPresenter = ({
  quotationForm,
  requestForm,
  isQuotation
}: Props) => {
  const { header, img } = useStyles();
  const history = useHistory();

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        component="div"
        className={header}
        onClick={() => {
          history.push('/');
        }}
      >
        <img
          width={77}
          height={20}
          alt=""
          src={assets.LOGO_MEDIUM}
          className={img}
        />
        <CustomizedTypography variant="subtitle2" color="textSecondary">
          해당 요청서는 캐파(CAPA)에서 제공하는 요청서 양식입니다.
        </CustomizedTypography>
      </Grid>
      <Grid item xs={12}>
        {isQuotation ? quotationForm : requestForm}
      </Grid>
    </Grid>
  );
};

export default ClipBoardPresenter;

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    height: '90px',
    borderBottom: `1px solid ${colorSet.gray200}`,
    padding: '20px 0px',
    cursor: 'pointer'
  },
  img: {
    marginBottom: 11
  }
}));
